import React from 'react'
import './success.css'
import success from '../../images/success.png'
function Success() {
    return (
        <>

            <section className='consultancy-section'>
                <div className="consultancy">

                    <img src={success} alt="" />

                    <h1 className='consultancy-heading'>  TESTIMONIAL  </h1>




                </div>
            </section>




            {/* <section className='deepak-jain-section testimonial-bg' id='mayank'>
                <div className="container">

                    <div className="deepak-detail row align-items-center">


                        <div className="success-vidio col-md-6">
                            <img src={logo} alt="" />
                        </div>

                        <div className="deepak-text col-md-6">
                            <h2 className='fw-bold'>Mayank Jain</h2>
                            <h4 className='mb-3'><strong style={{ color: '#9D3B24' }}>The Turning Point:How Naturopathy Saved My Life
                            </strong></h4>

                            <h5 className='fw-bold mb-3' style={{ textAlign: 'justify' }}>"In 2005, my life took a sudden, unexpected turn. I was in my second year of engineering, full of dreams and aspirations, when a devastating accident left me with a severe head injury,  straight into the Comma. Doctors treated me with several high dose medicines to wake me up and finally took 3 days.   I woke up in a haze—my vision blurred, lost my past memory, every word I tried to speak caught in an agonizing stammer, broken eye bone. Doctors continued the treatment with 23 medicines a day and several injections on my body.  Doctors gave my family two choices: opt for a risky operation with no guarantee or take me home with slim hopes of recovery. But amidst the despair, my Badepapa, Dr. Suresh Jain, stepped forward with a third option—one rooted in the healing power of nature. What followed was a journey of resilience, faith, and an incredible recovery that would forever change my perspective on life and healing."</h5>

                            <h5 className='fw-bold mb-3' style={{ textAlign: 'justify' }}>"It took almost 1 month in a Naturopathy hospital undergone several therapies, yoga sessions and unique diet which make me remember my past partially. I realized where am I and what am I doing. For next several years, followed naturopathy to bring life back to normal as winters brings lot of trouble in the body. Naturopathy helped correcting blurred vision and stammering issue."</h5>

                            <h5 className='fw-bold mb-3' style={{ textAlign: 'justify' }}>"I should thank to Badepapa and Dr Raghvendra Singh to bring my life back to normal, rather a new life."</h5>
                        </div>
                    </div>

                </div>
            </section>

            <section className="success-detail-section pantagon-rotate" id='sunita'>
                <div className="container">
                    <div className='book'>
                        <div className="book-text">
                            <h2>Sunita Jain, Sagar</h2>
                            <p>"Living with an autoimmune condition like HLA-B27 felt overwhelming until I found a natural path to relief. Through naturopathy, acupressure, and Sujok therapy, I’ve gained remarkable control over my health without the burden of medications."</p>
                        </div>
                        <div className="success-vidio image-wrapper">
                            <iframe
                                width="560"
                                height="315"
                                src="https://www.youtube.com/embed/bRdlAxJ_JfA"
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                </div>
            </section>*/}



            <section className="success-detail-section testimonial-bg" id='monica'>
                <div className="container">
                    <div className='book'>
                        <div className="success-vidio image-wrapper-left">
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/tU61PvDCyak?si=X1Y__MmQd2pEl2Ds" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>

                        <div className="book-text">
                            <h2> Monika Jain</h2>
                            <p>"Naturopathy has been a game-changer in managing my health condition. I've found relief through natural methods that truly respect my body."</p>
                        </div>

                    </div>
                </div>
            </section>



            <section className="success-detail-section pantagon-rotate" id='pragati'>
                <div className="container">
                    <div className='book'>


                        <div className="book-text">
                            <h2> Dr. Pragati Jain</h2>
                            <p>"With a few simple, nature-based lifestyle changes, I lost weight from 62 kg to 56 kg—completely side-effect-free. It’s amazing how natural choices can improve our health."</p>
                        </div>
                        <div className="success-vidio image-wrapper">
                            <img src="/images/prgati_jain.png" alt="" />
                        </div>

                    </div>
                </div>
            </section>



            <section className='deepak-jain-section testimonial-bg' id='deepak'>
                <div className="container">

                    <div className="deepak-detail row align-items-center">


                        <div className="success-vidio col-md-6 image-wrapper-left">
                            <img src='/images/deepak-jain.png' alt="" />
                        </div>

                        <div className="deepak-text col-md-6">
                            <h2 className='fw-bold'>Deepak Jain</h2>

                            <h5 className='fw-bold mb-3' style={{ textAlign: 'justify' }}>"I had been suffering from a persistent cough for almost four years. I tried allopathic, homeopathic, and Ayurvedic treatments, but the relief was only temporary, and the problem kept recurring."

                                On February 16, 2022, when my cough returned, I consulted all the local doctors, but when they couldn’t provide a solution, they advised me to seek help from a specialist. I then reached out to Guruji Pt. Vikas Ji Chhabra in Indore. He suggested I try naturopathy under the guidance of Pt. Sumat Prakash Ji. Due to certain constraints, I couldn’t visit him in person but managed to speak to him over the phone. Pt. Sumat Prakash Ji advised me to consult Dr. Suresh Jain Bhind (Tauji).

                                Tauji advised me to give up grains and pulses for 10 days and follow hydrotherapy and other naturopathy methods along with it. I did it disciplinedly and gradually increased it to 30 days. After this procedure, I got a lot of relief from my cough, which completely strengthened my faith in Naturopathy.

                                Following this, I enrolled in the NDDY course. While studying this course, I have not only applied these practices to my own life but also encouraged others to adopt naturopathy. It has played a transformative role in improving my life."</h5>
                        </div>
                    </div>

                </div>
            </section>

            <section className="success-detail-section pantagon-rotate" id='sikha'>
                <div className="container">
                    <div className='book'>


                        <div className="book-text">
                            <h2>Sikha Jain</h2>
                            <h4 className='fw-bold text-start mb-4'><strong>Homemaker, Dhar</strong></h4>
                            <p>"I have experienced a remarkable transformation in my life through this journey. I’ve successfully brought my diabetes under complete control and actively help those around me improve their health. Anuyog's Youtube videos have also been incredibly helpful—they deliver powerful messages in a simple, concise manner, guiding us on what’s right and what’s not."
                            </p>
                        </div>
                        <div className="success-vidio image-wrapper">
                            <img src="/images/sikha-jain.jpeg" alt="" />
                        </div>

                    </div>
                </div>
            </section>


            <section className="success-detail-section testimonial-bg" id='rajiv'>
                <div className="container">
                    <div className='book'>

                    <div className="success-vidio image-wrapper-left">
                            <img src="/images/rajiv_borar.jpeg" alt="" />
                        </div>


                        <div className="book-text">
                            <h2> Rajiv Borar</h2>
                            <h4 className='fw-bold text-start mb-4'><strong>Underwriter, Munich Re, Mumbai</strong></h4>
                            <p>"The Anuyog Institute's resources have been incredibly impactful in helping me lead a healthier and more balanced lifestyle. Their content, grounded in natural sciences, Ayurveda, and sustainable practices, provides easy-to-follow advice on improving physical and mental well-being. I appreciate how each video offers practical solutions, whether it’s tips for natural healing, yoga techniques, or mindful living. The expert guidance and evidence-based insights have motivated me to adopt small yet significant changes in my daily routine, helping me feel more energized and connected to nature. Anuyog’s approach has truly inspired me to live a more sustainable and fulfilling life."</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="success-detail-section pantagon-rotate" id='mohsin'>
                <div className="container">
                    <div className='book'>


                        <div className="book-text">
                            <h2> Mohsin</h2>
                            <h4 className='fw-bold text-start mb-4'><strong>Sr. CSA Teleperformance, Mumbai</strong></h4>
                            <p>"With the help of Anuyog, I am now more well versed with different ways of leading a healthy lifestyle and also the combination of foods that are good and help in maintaining  good health."
                            </p>
                        </div>
                        <div className="success-vidio image-wrapper">
                            <img src="/images/mohsin.jpeg" alt="" />
                        </div>

                    </div>
                </div>
            </section>

            <section className="success-detail-section testimonial-bg" id='priyanka'>
                <div className="container">
                    <div className='book'>

                    <div className="success-vidio image-wrapper-left">
                            <img src="/images/priyanka.jpg" alt="" />
                        </div>


                        <div className="book-text">
                            <h2>Priyanka Bhargava</h2>
                            <h4 className='fw-bold text-start mb-4'><strong>Delivery Director, VRIZE, New Delhi</strong></h4>
                            <p>"Embracing natural healing techniques has been a transformative journey for me. As a first hand experience, I have seen immense growth in my son's immunity when we opted for natural cure. Over the years, I have become a firm believer in holistic healing rather than treatment of symptoms. Anuyog Institute's approach aligns with my belief and it's resources/videos are very informative. The details shared in their videos are supported with the evidence and facts. Their guidance is very easy to follow and has helped me to take charge of not only my but my family member's health naturally and sustainably."
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="success-detail-section pantagon-rotate" id='rahul'>
                <div className="container">
                    <div className='book'>


                        <div className="book-text">
                            <h2>Rahul Sharma</h2>
                            <h4 className='fw-bold text-start mb-4'><strong> Founder, Gayatri Sublimation Prints, Prayagraj</strong></h4>
                            <p>"Anuyog has played a significant role in transforming my life, enhancing my physical, mental, and emotional well-being. Through practices like yoga, meditation, a balanced diet, and natural remedies, I not only strengthened my body but also experienced positive changes in my mindset and lifestyle. It taught me to trust my body’s ability to heal itself, rather than relying on medications. Today, I feel more energetic, calm, and positive. I sincerely thank the entire Anuyog team for their impactful contribution to this journey."
                            </p>
                        </div>
                        <div className="success-vidio image-wrapper">
                            <img src="/images/rahul.jpeg" alt="" />
                        </div>

                    </div>
                </div>
            </section>

            <section className="success-detail-section testimonial-bg" id='aashish'>
                <div className="container">
                    <div className='book'>

                    <div className="success-vidio image-wrapper-left">
                            <img src="/images/aashish.jpeg" alt="" />
                        </div>


                        <div className="book-text">
                            <h2>Ashish Sharma</h2>
                            <h4 className='fw-bold text-start mb-4'><strong> Data Scientist, Swiss Re, Bangalore</strong></h4>
                            <p>"Adopting a natural lifestyle with Anuyog, I've felt so much better. In a world full of chemicals and processed products, I'm thankful for the knowledge that helps me avoid them. This lifestyle keeps me healthy, away from medications, and helps me live a more balanced and fulfilling life.
                            "</p>
                        </div>
                    </div>
                </div>
            </section>





        </>
    )
}

export default Success
